import { FormControl } from '@angular/forms';
import { EntityTypes } from '@bullhorn/bullhorn-types';
import { IFieldMeta } from './meta-data.service';

class EntityGroup extends EntityTypes {
  static allowedEntities(): any[] {
    return [];
  }

  static isContains(entityName: AllPrimaryEntitiesNames): boolean {
    return this.allowedEntities().findIndex(en => {
      return en === entityName;
    }) > -1;
  }

  static formatToEntity(urlEntity: string): AllPrimaryEntitiesNames {
    const urlElements = urlEntity.split('-');
    const urlFormatted: string[] = urlElements.map((urlElement) => {
      return urlElement[0].toUpperCase() + urlElement.substring(1);
    });
    return urlFormatted.join('') as AllPrimaryEntitiesNames;
  }

  static formatToURL(entityName: AllPrimaryEntitiesNames): string {
    const entityNameElements = entityName.split(/(?=[A-Z])/);
    return entityNameElements.join('-').toLowerCase();
  }
}

// TODO write exclude more proper
export declare type CoreEntityName =
  Exclude<keyof typeof CoreEntitiesTypes, 'allowedEntities' | 'isContains' | 'prototype'>;

export class CoreEntitiesTypes extends EntityGroup implements EntityTypes {
  static Candidate = EntityTypes.Candidate;
  static ClientContact = EntityTypes.ClientContact;
  static ClientCorporation = EntityTypes.ClientCorporation;
  static JobOrder = EntityTypes.JobOrder;
  static Placement = EntityTypes.Placement;
  static Lead = EntityTypes.Lead;
  static Opportunity = EntityTypes.Opportunity;

  static allowedEntities(): CoreEntityName[] {
    return [
      this.Candidate,
      this.ClientContact,
      this.ClientCorporation,
      this.JobOrder,
      this.Placement,
      this.Lead,
      this.Opportunity
    ];
  }
}

// TODO write exclude more proper
export declare type FileAttachmentEntityName =
  Exclude<keyof typeof FileAttachmentEntitiesTypes, 'allowedEntities' | 'isContains' | 'prototype'>;

export class FileAttachmentEntitiesTypes extends EntityGroup implements EntityTypes {
  static CandidateFileAttachment = EntityTypes.CandidateFileAttachment;
  static CertificationFileAttachment = EntityTypes.CertificationFileAttachment;
  static ClientContactFileAttachment = EntityTypes.ClientContactFileAttachment;
  static ClientCorporationFileAttachment = EntityTypes.ClientCorporationFileAttachment;
  static JobOrderFileAttachment = EntityTypes.JobOrderFileAttachment;
  static OpportunityFileAttachment = EntityTypes.OpportunityFileAttachment;
  static PlacementFileAttachment = EntityTypes.PlacementFileAttachment;

  static allowedEntities(): FileAttachmentEntityName[] {
    return [
      this.CandidateFileAttachment,
      this.CertificationFileAttachment,
      this.ClientContactFileAttachment,
      this.ClientCorporationFileAttachment,
      this.JobOrderFileAttachment,
      this.OpportunityFileAttachment,
      this.PlacementFileAttachment,
    ];
  }
}

// TODO write exclude more proper
export declare type AdditionalEntityName =
  Exclude<keyof typeof AdditionalEntitiesTypes, 'allowedEntities' | 'isContains' | 'prototype'>;

export class AdditionalEntitiesTypes extends EntityGroup implements EntityTypes {
  static Appointment = EntityTypes.Appointment;
  static BillingProfile = EntityTypes.BillingProfile;
  static CandidateEducation = EntityTypes.CandidateEducation;
  static CandidateCertification = EntityTypes.CandidateCertification;
  static CandidateReference = EntityTypes.CandidateReference;
  static CandidateWorkHistory = EntityTypes.CandidateWorkHistory;
  static CertificationRequirement = EntityTypes.CertificationRequirement;
  static JobSubmission = EntityTypes.JobSubmission;
  static Note = EntityTypes.Note;
  static PlacementCommission = EntityTypes.PlacementCommission;
  static Sendout = EntityTypes.Sendout;
  static Task = EntityTypes.Task;
  static Tearsheet = EntityTypes.Tearsheet;

  static allowedEntities(): AdditionalEntityName[] {
    return [
      this.Appointment,
      this.BillingProfile,
      this.CandidateEducation,
      this.CandidateCertification,
      this.CandidateReference,
      this.CandidateWorkHistory,
      this.CertificationRequirement,
      this.JobSubmission,
      this.Note,
      this.PlacementCommission,
      this.Sendout,
      this.Task,
      this.Tearsheet,
    ];
  }
}

// TODO write exclude more proper
export declare type CustomObjectEntityName =
  Exclude<keyof typeof CustomObjectEntitiesTypes, 'allowedEntities' | 'isContains' | 'prototype'>;

export class CustomObjectEntitiesTypes extends EntityGroup implements EntityTypes {

  // re-instantiated whole @bullhorn/bullhorn-types CustomObjectInstance's entities
  // todo support new updates to the lib
  static ClientCorporationCustomObjectInstance1 = EntityTypes.ClientCorporationCustomObjectInstance1;
  static ClientCorporationCustomObjectInstance10 = EntityTypes.ClientCorporationCustomObjectInstance10;
  static ClientCorporationCustomObjectInstance11 = EntityTypes.ClientCorporationCustomObjectInstance11;
  static ClientCorporationCustomObjectInstance12 = EntityTypes.ClientCorporationCustomObjectInstance12;
  static ClientCorporationCustomObjectInstance13 = EntityTypes.ClientCorporationCustomObjectInstance13;
  static ClientCorporationCustomObjectInstance14 = EntityTypes.ClientCorporationCustomObjectInstance14;
  static ClientCorporationCustomObjectInstance15 = EntityTypes.ClientCorporationCustomObjectInstance15;
  static ClientCorporationCustomObjectInstance16 = EntityTypes.ClientCorporationCustomObjectInstance16;
  static ClientCorporationCustomObjectInstance17 = EntityTypes.ClientCorporationCustomObjectInstance17;
  static ClientCorporationCustomObjectInstance18 = EntityTypes.ClientCorporationCustomObjectInstance18;
  static ClientCorporationCustomObjectInstance19 = EntityTypes.ClientCorporationCustomObjectInstance19;
  static ClientCorporationCustomObjectInstance2 = EntityTypes.ClientCorporationCustomObjectInstance2;
  static ClientCorporationCustomObjectInstance20 = EntityTypes.ClientCorporationCustomObjectInstance20;
  static ClientCorporationCustomObjectInstance21 = EntityTypes.ClientCorporationCustomObjectInstance21;
  static ClientCorporationCustomObjectInstance22 = EntityTypes.ClientCorporationCustomObjectInstance22;
  static ClientCorporationCustomObjectInstance23 = EntityTypes.ClientCorporationCustomObjectInstance23;
  static ClientCorporationCustomObjectInstance24 = EntityTypes.ClientCorporationCustomObjectInstance24;
  static ClientCorporationCustomObjectInstance25 = EntityTypes.ClientCorporationCustomObjectInstance25;
  static ClientCorporationCustomObjectInstance26 = EntityTypes.ClientCorporationCustomObjectInstance26;
  static ClientCorporationCustomObjectInstance27 = EntityTypes.ClientCorporationCustomObjectInstance27;
  static ClientCorporationCustomObjectInstance28 = EntityTypes.ClientCorporationCustomObjectInstance28;
  static ClientCorporationCustomObjectInstance29 = EntityTypes.ClientCorporationCustomObjectInstance29;
  static ClientCorporationCustomObjectInstance3 = EntityTypes.ClientCorporationCustomObjectInstance3;
  static ClientCorporationCustomObjectInstance30 = EntityTypes.ClientCorporationCustomObjectInstance30;
  static ClientCorporationCustomObjectInstance31 = EntityTypes.ClientCorporationCustomObjectInstance31;
  static ClientCorporationCustomObjectInstance32 = EntityTypes.ClientCorporationCustomObjectInstance32;
  static ClientCorporationCustomObjectInstance33 = EntityTypes.ClientCorporationCustomObjectInstance33;
  static ClientCorporationCustomObjectInstance34 = EntityTypes.ClientCorporationCustomObjectInstance34;
  static ClientCorporationCustomObjectInstance35 = EntityTypes.ClientCorporationCustomObjectInstance35;
  static ClientCorporationCustomObjectInstance4 = EntityTypes.ClientCorporationCustomObjectInstance4;
  static ClientCorporationCustomObjectInstance5 = EntityTypes.ClientCorporationCustomObjectInstance5;
  static ClientCorporationCustomObjectInstance6 = EntityTypes.ClientCorporationCustomObjectInstance6;
  static ClientCorporationCustomObjectInstance7 = EntityTypes.ClientCorporationCustomObjectInstance7;
  static ClientCorporationCustomObjectInstance8 = EntityTypes.ClientCorporationCustomObjectInstance8;
  static ClientCorporationCustomObjectInstance9 = EntityTypes.ClientCorporationCustomObjectInstance9;

  static JobOrderCustomObjectInstance1 = EntityTypes.JobOrderCustomObjectInstance1;
  static JobOrderCustomObjectInstance10 = EntityTypes.JobOrderCustomObjectInstance10;
  static JobOrderCustomObjectInstance2 = EntityTypes.JobOrderCustomObjectInstance2;
  static JobOrderCustomObjectInstance3 = EntityTypes.JobOrderCustomObjectInstance3;
  static JobOrderCustomObjectInstance4 = EntityTypes.JobOrderCustomObjectInstance4;
  static JobOrderCustomObjectInstance5 = EntityTypes.JobOrderCustomObjectInstance5;
  static JobOrderCustomObjectInstance6 = EntityTypes.JobOrderCustomObjectInstance6;
  static JobOrderCustomObjectInstance7 = EntityTypes.JobOrderCustomObjectInstance7;
  static JobOrderCustomObjectInstance8 = EntityTypes.JobOrderCustomObjectInstance8;
  static JobOrderCustomObjectInstance9 = EntityTypes.JobOrderCustomObjectInstance9;

  static OpportunityCustomObjectInstance1 = EntityTypes.OpportunityCustomObjectInstance1;
  static OpportunityCustomObjectInstance10 = EntityTypes.OpportunityCustomObjectInstance10;
  static OpportunityCustomObjectInstance2 = EntityTypes.OpportunityCustomObjectInstance2;
  static OpportunityCustomObjectInstance3 = EntityTypes.OpportunityCustomObjectInstance3;
  static OpportunityCustomObjectInstance4 = EntityTypes.OpportunityCustomObjectInstance4;
  static OpportunityCustomObjectInstance5 = EntityTypes.OpportunityCustomObjectInstance5;
  static OpportunityCustomObjectInstance6 = EntityTypes.OpportunityCustomObjectInstance6;
  static OpportunityCustomObjectInstance7 = EntityTypes.OpportunityCustomObjectInstance7;
  static OpportunityCustomObjectInstance8 = EntityTypes.OpportunityCustomObjectInstance8;
  static OpportunityCustomObjectInstance9 = EntityTypes.OpportunityCustomObjectInstance9;

  static PersonCustomObjectInstance1 = EntityTypes.PersonCustomObjectInstance1;
  static PersonCustomObjectInstance10 = EntityTypes.PersonCustomObjectInstance10;
  static PersonCustomObjectInstance11 = EntityTypes.PersonCustomObjectInstance11;
  static PersonCustomObjectInstance12 = EntityTypes.PersonCustomObjectInstance12;
  static PersonCustomObjectInstance13 = EntityTypes.PersonCustomObjectInstance13;
  static PersonCustomObjectInstance14 = EntityTypes.PersonCustomObjectInstance14;
  static PersonCustomObjectInstance15 = EntityTypes.PersonCustomObjectInstance15;
  static PersonCustomObjectInstance16 = EntityTypes.PersonCustomObjectInstance16;
  static PersonCustomObjectInstance17 = EntityTypes.PersonCustomObjectInstance17;
  static PersonCustomObjectInstance18 = EntityTypes.PersonCustomObjectInstance18;
  static PersonCustomObjectInstance19 = EntityTypes.PersonCustomObjectInstance19;
  static PersonCustomObjectInstance2 = EntityTypes.PersonCustomObjectInstance2;
  static PersonCustomObjectInstance21 = EntityTypes.PersonCustomObjectInstance21;
  static PersonCustomObjectInstance22 = EntityTypes.PersonCustomObjectInstance22;
  static PersonCustomObjectInstance23 = EntityTypes.PersonCustomObjectInstance23;
  static PersonCustomObjectInstance24 = EntityTypes.PersonCustomObjectInstance24;
  static PersonCustomObjectInstance25 = EntityTypes.PersonCustomObjectInstance25;
  static PersonCustomObjectInstance26 = EntityTypes.PersonCustomObjectInstance26;
  static PersonCustomObjectInstance27 = EntityTypes.PersonCustomObjectInstance27;
  static PersonCustomObjectInstance28 = EntityTypes.PersonCustomObjectInstance28;
  static PersonCustomObjectInstance29 = EntityTypes.PersonCustomObjectInstance29;
  static PersonCustomObjectInstance3 = EntityTypes.PersonCustomObjectInstance3;
  static PersonCustomObjectInstance30 = EntityTypes.PersonCustomObjectInstance30;
  static PersonCustomObjectInstance31 = EntityTypes.PersonCustomObjectInstance31;
  static PersonCustomObjectInstance32 = EntityTypes.PersonCustomObjectInstance32;
  static PersonCustomObjectInstance33 = EntityTypes.PersonCustomObjectInstance33;
  static PersonCustomObjectInstance34 = EntityTypes.PersonCustomObjectInstance34;
  static PersonCustomObjectInstance35 = EntityTypes.PersonCustomObjectInstance35;
  static PersonCustomObjectInstance4 = EntityTypes.PersonCustomObjectInstance4;
  static PersonCustomObjectInstance5 = EntityTypes.PersonCustomObjectInstance5;
  static PersonCustomObjectInstance6 = EntityTypes.PersonCustomObjectInstance6;
  static PersonCustomObjectInstance7 = EntityTypes.PersonCustomObjectInstance7;
  static PersonCustomObjectInstance8 = EntityTypes.PersonCustomObjectInstance8;
  static PersonCustomObjectInstance9 = EntityTypes.PersonCustomObjectInstance9;

  static PlacementCustomObjectInstance1 = EntityTypes.PlacementCustomObjectInstance1;
  static PlacementCustomObjectInstance10 = EntityTypes.PlacementCustomObjectInstance10;
  static PlacementCustomObjectInstance2 = EntityTypes.PlacementCustomObjectInstance2;
  static PlacementCustomObjectInstance3 = EntityTypes.PlacementCustomObjectInstance3;
  static PlacementCustomObjectInstance4 = EntityTypes.PlacementCustomObjectInstance4;
  static PlacementCustomObjectInstance5 = EntityTypes.PlacementCustomObjectInstance5;
  static PlacementCustomObjectInstance6 = EntityTypes.PlacementCustomObjectInstance6;
  static PlacementCustomObjectInstance7 = EntityTypes.PlacementCustomObjectInstance7;
  static PlacementCustomObjectInstance8 = EntityTypes.PlacementCustomObjectInstance8;
  static PlacementCustomObjectInstance9 = EntityTypes.PlacementCustomObjectInstance9;

  static allowedEntities(): CustomObjectEntityName[] {
    return [
      this.ClientCorporationCustomObjectInstance1,
      this.ClientCorporationCustomObjectInstance10,
      this.ClientCorporationCustomObjectInstance11,
      this.ClientCorporationCustomObjectInstance12,
      this.ClientCorporationCustomObjectInstance13,
      this.ClientCorporationCustomObjectInstance14,
      this.ClientCorporationCustomObjectInstance15,
      this.ClientCorporationCustomObjectInstance16,
      this.ClientCorporationCustomObjectInstance17,
      this.ClientCorporationCustomObjectInstance18,
      this.ClientCorporationCustomObjectInstance19,
      this.ClientCorporationCustomObjectInstance2,
      this.ClientCorporationCustomObjectInstance20,
      this.ClientCorporationCustomObjectInstance21,
      this.ClientCorporationCustomObjectInstance22,
      this.ClientCorporationCustomObjectInstance23,
      this.ClientCorporationCustomObjectInstance24,
      this.ClientCorporationCustomObjectInstance25,
      this.ClientCorporationCustomObjectInstance26,
      this.ClientCorporationCustomObjectInstance27,
      this.ClientCorporationCustomObjectInstance28,
      this.ClientCorporationCustomObjectInstance29,
      this.ClientCorporationCustomObjectInstance3,
      this.ClientCorporationCustomObjectInstance30,
      this.ClientCorporationCustomObjectInstance31,
      this.ClientCorporationCustomObjectInstance32,
      this.ClientCorporationCustomObjectInstance33,
      this.ClientCorporationCustomObjectInstance34,
      this.ClientCorporationCustomObjectInstance35,
      this.ClientCorporationCustomObjectInstance4,
      this.ClientCorporationCustomObjectInstance5,
      this.ClientCorporationCustomObjectInstance6,
      this.ClientCorporationCustomObjectInstance7,
      this.ClientCorporationCustomObjectInstance8,
      this.ClientCorporationCustomObjectInstance9,

      this.JobOrderCustomObjectInstance1,
      this.JobOrderCustomObjectInstance10,
      this.JobOrderCustomObjectInstance2,
      this.JobOrderCustomObjectInstance3,
      this.JobOrderCustomObjectInstance4,
      this.JobOrderCustomObjectInstance5,
      this.JobOrderCustomObjectInstance6,
      this.JobOrderCustomObjectInstance7,
      this.JobOrderCustomObjectInstance8,
      this.JobOrderCustomObjectInstance9,

      this.OpportunityCustomObjectInstance1,
      this.OpportunityCustomObjectInstance10,
      this.OpportunityCustomObjectInstance2,
      this.OpportunityCustomObjectInstance3,
      this.OpportunityCustomObjectInstance4,
      this.OpportunityCustomObjectInstance5,
      this.OpportunityCustomObjectInstance6,
      this.OpportunityCustomObjectInstance7,
      this.OpportunityCustomObjectInstance8,
      this.OpportunityCustomObjectInstance9,

      this.PersonCustomObjectInstance1,
      this.PersonCustomObjectInstance10,
      this.PersonCustomObjectInstance11,
      this.PersonCustomObjectInstance12,
      this.PersonCustomObjectInstance13,
      this.PersonCustomObjectInstance14,
      this.PersonCustomObjectInstance15,
      this.PersonCustomObjectInstance16,
      this.PersonCustomObjectInstance17,
      this.PersonCustomObjectInstance18,
      this.PersonCustomObjectInstance19,
      this.PersonCustomObjectInstance2,
      this.PersonCustomObjectInstance20,
      this.PersonCustomObjectInstance21,
      this.PersonCustomObjectInstance22,
      this.PersonCustomObjectInstance23,
      this.PersonCustomObjectInstance24,
      this.PersonCustomObjectInstance25,
      this.PersonCustomObjectInstance26,
      this.PersonCustomObjectInstance27,
      this.PersonCustomObjectInstance28,
      this.PersonCustomObjectInstance29,
      this.PersonCustomObjectInstance3,
      this.PersonCustomObjectInstance30,
      this.PersonCustomObjectInstance31,
      this.PersonCustomObjectInstance32,
      this.PersonCustomObjectInstance33,
      this.PersonCustomObjectInstance34,
      this.PersonCustomObjectInstance35,
      this.PersonCustomObjectInstance4,
      this.PersonCustomObjectInstance5,
      this.PersonCustomObjectInstance6,
      this.PersonCustomObjectInstance7,
      this.PersonCustomObjectInstance8,
      this.PersonCustomObjectInstance9,

      this.PlacementCustomObjectInstance1,
      this.PlacementCustomObjectInstance10,
      this.PlacementCustomObjectInstance2,
      this.PlacementCustomObjectInstance3,
      this.PlacementCustomObjectInstance4,
      this.PlacementCustomObjectInstance5,
      this.PlacementCustomObjectInstance6,
      this.PlacementCustomObjectInstance7,
      this.PlacementCustomObjectInstance8,
      this.PlacementCustomObjectInstance9
    ];
  }
}

export declare type AllPrimaryEntitiesNames = (CoreEntityName | FileAttachmentEntityName | AdditionalEntityName | CustomObjectEntityName);

export class AllPrimaryEntitiesTypes
  extends EntityGroup
  implements CoreEntitiesTypes, FileAttachmentEntitiesTypes, AdditionalEntitiesTypes, CustomObjectEntitiesTypes {
  static allowedEntities(): AllPrimaryEntitiesNames[] {
    return [
      ...CoreEntitiesTypes.allowedEntities(),
      ...FileAttachmentEntitiesTypes.allowedEntities(),
      ...AdditionalEntitiesTypes.allowedEntities(),
      ...CustomObjectEntitiesTypes.allowedEntities()
    ];
  }
}

export enum Entities {
  CANDIDATE = 'Candidate',
  CONTACT = 'ClientContact',
  COMPANY = 'ClientCorporation',
  JOB_ORDER = 'JobOrder',
  PLACEMENT = 'Placement',
  LEAD = 'Lead',
  OPPORTUNITY = 'Opportunity'
}

export enum BullhornFieldType {
  STRING = 'STRING',
  INTEGER = 'INTEGER',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  DOUBLE = 'DOUBLE',
  FLOAT = 'FLOAT',
  BIG_DECIMAL = 'BIG_DECIMAL',
  ADDRESS = 'ADDRESS',
  TO_MANY = 'TO_MANY',
  TO_ONE = 'TO_ONE',
  LONG_STRING = 'LONG_STRING',
  CERTIFICATION = 'CERTIFICATION',
  CERTIFICATION_GROUP = 'CERTIFICATION_GROUP',
  NOTE = 'NOTE',
  FIELD = 'FIELD'
}

export enum ActionsOperators {
  COPY = 'Copy value',
  MOVE = 'Move value',
  NULLIFY = 'NULL value',
  REPLACE = 'Replace value',
  REPLACE_RELATIVE = 'Replace with dynamic value',
  SWAP = 'Swap values',
  ADD = 'Add values',
  REMOVE = 'Remove values',
  CHANGE = 'Change value',
  APPEND = 'Append value',
  FORMAT = 'Format value',
  SUBSTITUTE = 'Substitute value',
  PREPEND = 'Prepend value',
  DELETE = 'Hard delete',
  INSERT = 'Insert',
  INSERT_MULTIPLE = 'Insert Multiple',
  MATHS = 'Maths: Set equal to',
  APPEND_ENTRY = 'Append entries',
  COUNT = 'Count values',
  CONCATENATE = 'Concatenate',
  AIASSIST = 'AIASSIST',
  AWESOMEDOCS = 'AWESOMEDOCS',
  ENRICH = 'ENRICH',
  AIASSIST_NOTE = 'AIASSIST_NOTE',
  PARSE_RESUME = 'PARSE_RESUME',
}

// TODO: use in the future?
// export interface IBullhornSourceConfig {
//   entity: string;
//   criteria?: CriteriaData[];
// }
//
// export interface IBullhornProcessorConfig {
//   entity: string;
//   type: string;
//   source: string;
//   sourceType: string;
//   destination: string;
//   destinationType: string;
// }

export interface IRuleViewState {
  expanded?: boolean; // TODO: Can be removed once datarules_folders Feature Flag is removed from feature-flag.service.ts
  dirty: boolean;
  scheduleOpen?: boolean;
  scheduleSaving?: boolean;
}

export enum SidebarFolderId {
  ALL_RULES = 'all',
  ARCHIVE = 'archive',
}

export const ARCHIVE_FOLDER_NAME = 'Archive';

// since a folder is a virtual view, the id could be tag id, or some fixed id
// similarly, the name could be the tag name or related to a rule attribute like "Scheduled"
export interface IFolder {
  id: string;
  name: string;
}

export interface ISidebarFolder {
  id: string;
  name: string;
  icon: string; // Should this be optional?
  count: number;
  colour?: string;
  outlinedIcon?: boolean;
  tooltip?: string;
}

export interface IRuleTag {
  id: string;
  name: string;
  corpId: string;
  userId: string;
  icon?: string;
  colour?: string;   // is this hex code? - AJ: YES
  created: number;  // TODO: check what type server returns
  updated: number;  // TODO: check what type server returns
}

export interface ITaggedRule {
  ruleId: string;
  tagId: string;
}

export interface IDataRule {
  ruleData: RuleData;
  viewState: IRuleViewState;
}

export type DataRuleId = 0 | string;

// TODO: Break out into separate model's?
export class RuleData {
  id: DataRuleId;
  name?: string;
  type: string;
  isArchived: boolean = false;
  // folders are a virtual view of tags AND rule attributes (e.g. scheduled), should it really be on this class?
  folders?: IFolder[];
  tagIds?: string[];
  source: {
    type: string;
    id: number;
    config: any;
  };
  action: {
    type: string;
    id: number;
    config: any | {
      entity: string;
      steps: ActionData[];
    }
  };
  recordUpdateLimit?: number;

  // convenience constructor until it's all sorted - only works for Bullhorn
  constructor(
    id: DataRuleId,
    name: string = '',
    entity: string = '',
    criteria: CriteriaData[] = [],
    actions: ActionData[] = []
  ) {
    this.id = id;
    this.name = name;
    this.type = 'BullhornBullhornUpdate';

    this.source = {type: 'bullhornDataSource', id: 0, config: {}};
    this.source.config.entity = entity;
    this.source.config.criteria = criteria;

    this.action = {type: 'bullhornUpdateAction', id: 0, config: {}};
    this.action.config.entity = entity;
    this.action.config.steps = actions;

  }

  static clone(rule: RuleData): RuleData {
    return JSON.parse(JSON.stringify(rule));
  }
}

export class CriteriaData {
  fieldName: string;
  fieldType: string;
  operator: string;
  value: any | any[] | AddressData;
  secondaryDescriptor?: string;

  constructor(
    fieldName: string = '',
    fieldType: string = '',
    operator: string = '',
    secondaryDescriptor?: string,
    value?: any | any[] | AddressData
  ) {
    this.fieldName = fieldName;
    this.fieldType = fieldType;
    this.operator = operator;
    this.secondaryDescriptor = secondaryDescriptor;
    this.value = value;
  }

  static serialize(cr: CriteriaData): Omit<CriteriaData, 'secondaryDescriptor'> {
    const {secondaryDescriptor, fieldName, ...rest} = cr;
    const composedFieldName = secondaryDescriptor ? `${secondaryDescriptor}.${fieldName}` : fieldName;
    return {...rest, fieldName: composedFieldName};
  }
}

export type RawActionData = Omit<ActionData,
  'sourceDescriptor' | 'destinationDescriptor'
  | 'entitySourceType' | 'entityDestinationType' | 'sourceId'>;

export class ActionData {
  type: string;
  source?: string;
  sourceDescriptor?: string;
  sourceType?: string;
  destination?: string;
  destinationDescriptor?: string;
  destinationType?: string;
  value: any | any[] | AddressData | InsertActionValue | ParseResumeActionValue;
  fieldName?: any;
  entityType?: string;    // used when destinationTYpe is TO_MANY
  noteAction?: string;
  noteIsDeleted?: boolean;
  lite?: boolean;
  constructor(
    type: string = '',
    source: string = '',
    sourceType: string = '',
    destination: string = '',
    destinationType: string = '',
    sourceDescriptor?: string,
    destinationDescriptor?: string,
    value?: any | any[] | AddressData | InsertActionValue | ParseResumeActionValue,
    fieldName?: any
  ) {
    this.type = type;
    this.source = source;
    this.sourceDescriptor = sourceDescriptor;
    this.sourceType = sourceType;
    this.destination = destination;
    this.destinationDescriptor = destinationDescriptor;
    this.destinationType = destinationType;
    this.value = value;
    this.fieldName = fieldName;
  }
}

export class InsertActionData extends ActionData {
  value: any;
  destinationType: BullhornFieldType;

  constructor(
    value: InsertActionValue | AddNoteActionValue,
    destinationType: BullhornFieldType,
    type?: string
  ) {
    super(
      type ?? 'INSERT',
      '',
      '',
      '',
      destinationType,
      '',
      '',
      value
    );
    this.value = value;
  }
}

export class InsertActionValue {
  entitySourceType?: string;
  entityDestinationType?: string;
  sourceId?: string;

  constructor(
    entitySourceType?,
    entityDestinationType?,
    sourceId?
  ) {
    this.entitySourceType = entitySourceType;
    this.entityDestinationType = entityDestinationType;
    this.sourceId = sourceId;
  }
}

export interface AddNoteActionValue {
  action?: string;
  comments?: string;
  isDeleted?: boolean;
  commentsMode: 'SPECIFY' | 'RULE_SUMMARY'
}

export interface ParseResumeActionValue {
  resumeType: string;
  fieldToPopulateWithResume: string;
  fieldToPopulateWithResumeDate: string;
}

export interface IFormActionData extends ActionData, InsertActionValue, AddNoteActionValue, ParseResumeActionValue {
}

export class AddressData {
  address1: string | undefined;
  address2: string | undefined;
  city: string | undefined;
  state: string | undefined;
  zip: string | undefined;
  countryID: string | undefined;

  constructor(
    address1?,
    address2?,
    city?,
    state?,
    zip?,
    countryID?
  ) {
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.zip = zip;
    this.countryID = countryID;
  }
}

// ---- TODO: move these somewhere else? ----
export interface IOperator {
  label: string;
  value: string;
}

export interface IAddressFields { // TODO: THIS NEEDS POPULATING FROM META
  name: string;
  controlName: string;
  control: FormControl;
  enabled: boolean;
}

export class Operators {
  static readonly Equals = {label: 'equals', value: 'equals'};
  static readonly NotEquals = {label: 'does not equal', value: 'notEquals'};
  static readonly LessThan = {label: 'less than', value: 'lessThan'};
  static readonly GreaterThan = {label: 'greater than', value: 'greaterThan'};
  static readonly LessThanOrEquals = {label: 'less than or equals', value: 'lessThanOrEquals'};
  static readonly GreaterThanOrEquals = {label: 'greater than or equals', value: 'greaterThanOrEquals'};
  static readonly In = {label: 'includes any of', value: 'in'};
  static readonly NotIn = {label: 'does not include any of', value: 'notIn'};
  static readonly Before = {label: 'before', value: 'before'};
  static readonly After = {label: 'after', value: 'after'};
  static readonly isNull = {label: 'is null', value: 'isNull'};
  static readonly isNotNull = {label: 'is not null', value: 'isNotNull'};
  static readonly within = {label: 'within', value: 'within'};
  static readonly notWithin = {label: 'not within', value: 'notWithin'};
  static readonly HasSome = {label: 'has some', value: 'hasSome'};
  static readonly HasNone = {label: 'has none', value: 'hasNone'};

  static getOperators(fieldMeta: IFieldMeta): IOperator[] {
    const fieldOps = Operators.FieldToOperatorMap[fieldMeta.fieldName];
    return fieldOps ? fieldOps : Operators.FieldTypeToOperatorsMap[fieldMeta.metaType];
  }

  static getCompareFieldOperators(fieldType: string): IOperator[] {
    const numericTypes = [BullhornFieldType.INTEGER, BullhornFieldType.DOUBLE, BullhornFieldType.FLOAT, BullhornFieldType.BIG_DECIMAL];
    if (numericTypes.includes(fieldType as BullhornFieldType)) {
      return [
        Operators.Equals, Operators.NotEquals,
        Operators.GreaterThan, Operators.GreaterThanOrEquals,
        Operators.LessThan, Operators.LessThanOrEquals
      ];
    }
    return [Operators.Equals, Operators.NotEquals];
  }

  private static readonly FieldTypeToOperatorsMap = {
    // [MetaData.string]: [ Operators.Equals, Operators.NotEquals, Operators.In ],   // TODO: change to this?
    STRING: [Operators.Equals, Operators.NotEquals, Operators.In, Operators.NotIn, Operators.isNull, Operators.isNotNull],
    BOOLEAN: [Operators.Equals, Operators.isNull, Operators.isNotNull],
    INTEGER: [Operators.Equals, Operators.NotEquals, Operators.LessThan, Operators.GreaterThan,
      Operators.LessThanOrEquals, Operators.GreaterThanOrEquals, Operators.In, Operators.NotIn, Operators.isNull, Operators.isNotNull],
    DOUBLE: [Operators.Equals, Operators.NotEquals, Operators.LessThan, Operators.GreaterThan,
      Operators.LessThanOrEquals, Operators.GreaterThanOrEquals, Operators.In, Operators.NotIn, Operators.isNull, Operators.isNotNull],
    FLOAT: [Operators.Equals, Operators.NotEquals, Operators.LessThan, Operators.GreaterThan,
      Operators.LessThanOrEquals, Operators.GreaterThanOrEquals, Operators.In, Operators.NotIn, Operators.isNull, Operators.isNotNull],
    BIG_DECIMAL: [Operators.Equals, Operators.NotEquals, Operators.LessThan, Operators.GreaterThan,
      Operators.LessThanOrEquals, Operators.GreaterThanOrEquals, Operators.In, Operators.NotIn, Operators.isNull, Operators.isNotNull],
    DATE: [Operators.Equals, Operators.NotEquals, Operators.Before, Operators.After, Operators.isNull, Operators.isNotNull,
      Operators.within, Operators.notWithin],
    TO_MANY: [Operators.Equals, Operators.HasSome, Operators.HasNone, Operators.In, Operators.NotIn],
    TO_ONE: [Operators.Equals, Operators.isNull, Operators.isNotNull],
    ADDRESS: [Operators.Equals, Operators.NotEquals, Operators.isNull, Operators.isNotNull, Operators.In, Operators.NotIn]
  };

  private static readonly FieldToOperatorMap = {
    id: [Operators.Equals, Operators.In, Operators.NotIn]
  };
}

export interface ITask {
  ruleId: number;
  state: string;
}

export interface IDataRulesTasks {
  // server fields
  created: number;
  id: string;
  recordsFailed: number;
  recordsProcessed: number;
  noUpdateRequired?: number;
  recordUpdateLimit?: number;
  recordsNotReached?: number;
  stoppedOnLimit?: boolean;
  ruleId: string; // The task's rule ID
  sourceRuleId: string; // Required for rolled back rules
  startTime: number;
  eta: number;
  state: TaskState;
  totalRecords: number;
  updated: number;
  userId: number;
  userName?: string;
  entity: string;
  entityLabel?: string;
  sortKey: string;

  // ui fields
  name: string;
  within30Days: boolean;
  ruleDeleted: boolean;
  isRollbackTask: boolean;
  scheduledFrequency?: string;
}

export interface IDataRulesHistoryTasks extends IDataRulesTasks {
  name: string;
  instances: IDataRulesTasks[];
}

export interface IDataSource {
  id: number;
  displayId?: string;
  fieldName: string;
  status: string;
  value?: string;
}

export class Samples {
  total: number;
  updateSamples: UpdateSamples[];

  constructor(
    total: number,
    updateSamples: UpdateSamples[]
  ) {
    this.total = total;
    this.updateSamples = updateSamples;
  }
}

export class UpdateSamples {
  id: number;
  changedFields: ChangedField[];

  constructor(
    id: number,
    changedFields: ChangedField[]
  ) {
    this.id = id;
    this.changedFields = changedFields;
  }
}

export class ChangedField {
  fieldName: string;
  fieldType: BullhornFieldType;
  oldValue: any;
  newValue: any;

  constructor(
    fieldName: string,
    fieldType: BullhornFieldType,
    oldValue: any,
    newValue: any
  ) {
    this.fieldName = fieldName;
    this.fieldType = fieldType;
    this.oldValue = oldValue;
    this.newValue = newValue;
  }
}

export enum TaskState {
  COMPLETED = 'Completed',
  ERROR = 'Failed',
  PRE_PROCESS = 'Preparing',
  POST_PROCESS = 'Finalising',
  QUEUED = 'Queued',
  ROLLING_BACK = 'Reverting',
  ROLLED_BACK = 'Reverted',
  RUNNING = 'In Progress',
  STOPPED = 'Stopped',
  STOPPING = 'Stopping', // exists in server enum but is not used
  RESUMING = 'Resuming', // this state does not exist on the server - do we need it?
  SUBMITTED = 'Submitted',
  CANCELLED = 'Cancelled',
  CANCELING = 'Canceling',
  STOPPED_ROLLBACK = 'Revert Stopped'
}

export interface IScheduleResponse {
  ruleName: string;
  ruleExpression: string;
  enabled: boolean;
  startDate: string;
  endDate: string;
}

export interface IScheduleUnit {
  unit: string;
  value: string;
}

export interface ISchedulePeriod {
  value: number;
  idUnit: string;
}

export interface IWithinFields {
  name: string;
  value: number;
}

export enum TimeOperator {
  // @ts-ignore
  PAST = 'the past',
  // @ts-ignore
  NEXT = 'the next'
}

export enum UnitsOfTime {
  // @ts-ignore
  MINUTE = 'minute(s)',
  // @ts-ignore
  HOUR = 'hour(s)',
  // @ts-ignore
  DAY = 'day(s)',
  // @ts-ignore
  WEEK = 'week(s)',
  // @ts-ignore
  MONTH = 'month(s)',
  // @ts-ignore
  YEAR = 'Year(s)'
}

export enum DefaultEntities {
  DEFAULT_DATARULES_ENTITY = 'Candidate'
}

export interface IRuleStats {
 ruleId: string;
 name: string;
 entity: string;
 timesRun: number;
 state: TaskState;
 startTime: number;
 recordsProcessed: number;
 recordsFailed: number;
 noUpdateRequired?: number;
 recordUpdateLimit?: number;
 recordsNotReached?: number;
 stoppedOnLimit?: boolean;
 totalRecords: number;
 userId: number;
 userName?: string;
 scheduledFrequency?: string;
 isDeleted?: boolean;
 isArchived?: boolean;
}

export enum ObjectType {
  VALUE = 'VALUE',
  FIELD = 'FIELD'
}

export interface IPromptProfile {
  action: string;
  anonymise: boolean;
  entityType: string;
  explanationDifficulty: string;
  format: string;
  outputFieldName: string;
  outputLanguage: string;
  removeBias: boolean;
  resultLength: string;
  role: string;
  tone: string;
  showContext: boolean;
  additionalContext: string;
  corpId: string;
  sortKey: string;
  title: string;
}

export interface IAwesomeDocsWorkflowConfig {
  id: string;
  clientId: string;
  clientNamespace: string;
  name: string;
  workflow: string;
  sections: any[];
  namespaces: string[];
  actionConfigs: any[];
  entity: string;
  isPublic: boolean;
  createdBy: string;
  dateCreated: string;
  modifiedBy: string;
  dateModified: string;
  filters: any[];
}
